import axios from "axios";
import Requests from "../../../utils/Requests"
import Validation from '../../../data/validation/validation'
import { PhoneValidationRule, StringValidationRule } from '../../../data/validation/rules'
import { ScrollIntoFirstError } from '../../../utils/UIHelper'
import { API_ENDPOINT } from "../../../config"

const getDefaultState = () => {
    return {
        loadingProfile: false,
        updating: false,
        profile: {
            email: "",
            firstname: "",
            middlename: "",
            lastname: "",
            specialty: "",
            photo: null,
            photoUrl: null,
            phone: "",
            enrollmentNumber: "",
            showInPublicDirectory: ""
        },
        errors: {},
        showError: false,
        alertError: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.profile.firstname, (error) => instance.state.errors.firstname = error, { min: { value: 2, error: "Invalid" }, max: { value: 25, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.profile.middlename, (error) => instance.state.errors.middlename = error, { min: { value: 0, error: "Invalid" }, max: { value: 25, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.profile.lastname, (error) => instance.state.errors.lastname = error, { min: { value: 2, error: "Invalid" }, max: { value: 25, error: "Invalid" } })
    validation.addValidationRule(PhoneValidationRule, instance.state.profile.phone, (error) => instance.state.errors.phone = error, { allowNull: false })
    validation.addValidationRule(StringValidationRule, instance.state.profile.specialty, (error) => instance.state.errors.specialty = error, { min: { value: 2, error: "Invalid" }, max: { value: 40, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.profile.enrollmentNumber, (error) => instance.state.errors.enrollmentNumber = error, { min: { value: 5, error: "Invalid" }, max: { value: 30, error: "Invalid" } })
    validation.addValidationRule(StringValidationRule, instance.state.profile.showInPublicDirectory, (error) => instance.state.errors.showInPublicDirectory = error, { min: { value: 4, error: "Invalid" }, max: { value: 5, error: "Invalid" } })

    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    ScrollIntoFirstError(errors)
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const loadProfile = instance => {

    instance.setState({
        ...instance.state,
        loadingProfile: true
    })

    Requests(instance.props)
        .withPost()
        .withData({})
        .withUrl('/api/member/profile')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleLoadProfileResponse(instance, response), error => handleError(instance, error))
}

const handleLoadProfileResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingProfile: false,
                profile: {
                    ...response.data.profile,
                    showInPublicDirectory: response.data.profile.showInPublicDirectory === true ? "true" : "false"
                }
            }, () => response.data.profile.photo !== null && instance.service.getPhoto())
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingProfile: false
            })
            alert(response.message)
    }
}


const updateProfile = instance => {

    instance.setState({
        ...instance.state,
        updating: true
    })

    let data = {
        ...instance.state.profile
    }

    let formData = new FormData()

    Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
    });

    Requests(instance.props)
        .withPost()
        .withData(formData)
        .withUrl('/api/member/profile/update')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleUpdateProfileResponse(instance, response), error => handleError(instance, error))
}

const handleUpdateProfileResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "success",
                    text: "Updated Successfully"
                }
            }, () => response.data.profile.photo !== null && instance.service.getPhoto())
            break;
        default:
            instance.setState({
                ...instance.state,
                updating: false
            })
            alert(response.message)
    }
}

const getPhoto = (instance) => {

    instance.setState({
        ...instance.state,
        updating: true
    })

    axios.get(API_ENDPOINT + "/api/member/profile/photo?rev="+ Math.random(), {
        responseType: "blob", headers: {
            Authorization: instance.props.auth.authorizationToken
        }
    })
        .then(res => {
            const url = URL.createObjectURL(res.data);
            instance.setState({
                ...instance.state,
                updating: false,
                photoUrl: url
            })
        });
}

const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        updating: false,
        flag: {
            type: "",
            text: ""
        }
    })

    alert(error)

}

const Service = instance => {
    return {
        updateProfile: () => updateProfile(instance),
        isValid: () => isValid(instance),
        loadProfile: () => loadProfile(instance),
        getPhoto: () => getPhoto(instance),
        getDefaultState: () => getDefaultState(instance)
    }
}

export default Service